import { render, staticRenderFns } from "./SubmissionProgressBadge.vue?vue&type=template&id=d2940a42"
import script from "./SubmissionProgressBadge.vue?vue&type=script&lang=js"
export * from "./SubmissionProgressBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports